<template>
  <AppHeader />
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-lighter to-white p-4">
    <div class="max-w-lg w-full bg-white rounded-2xl shadow-xl border border-gray-100 px-8 py-10 flex flex-col items-center">
      <!-- Illustration -->
      <svg width="120" height="120" viewBox="0 0 120 120" fill="none" class="mb-6">
        <circle cx="60" cy="60" r="56" fill="#EEF2FF"/>
        <ellipse cx="60" cy="90" rx="32" ry="8" fill="#E0E7FF"/>
        <rect x="38" y="40" width="44" height="32" rx="8" fill="#22c55e"/>
        <rect x="46" y="48" width="28" height="8" rx="4" fill="#bbf7d0"/>
        <rect x="46" y="60" width="18" height="4" rx="2" fill="#bbf7d0"/>
        <circle cx="60" cy="56" r="2" fill="#22c55e"/>
        <circle cx="68" cy="56" r="2" fill="#22c55e"/>
      </svg>
      <h1 class="text-7xl font-extrabold text-primary leading-none mb-2 tracking-tight">404</h1>
      <h2 class="text-2xl sm:text-3xl font-semibold text-gray-800 mb-3">Oops! Page Not Found</h2>
      <p class="text-gray-500 mb-8 text-base sm:text-lg">
        Sorry, the page you're looking for doesn't exist or has been moved.<br>
        If you think this is a mistake, please contact support.
      </p>
      <router-link 
        to="/" 
        class="inline-flex items-center px-6 py-3 bg-primary text-white rounded-lg shadow hover:bg-primary-dark transition-colors duration-200 font-semibold text-base"
      >
        <span class="material-symbols-outlined mr-2 text-lg">arrow_back</span>
        Return to Home
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>
